import {type ActionsMap, createReducer} from 'redux-store';
import * as actionTypes from '../constants/exams-errors-action-types';

import type {MapOf} from 'immutable';

export type ExamsErrorsStore = {
    authError: MapOf<{
        traceId: string;
    }> | null;
    error: MapOf<{
        traceId: string;
    }> | null;
};

const initialState = (): ExamsErrorsStore => {
    return {
        authError: null,
        error: null,
    };
};

const actionsMap: ActionsMap<ExamsErrorsStore> = {
    [actionTypes.SET_AUTH_ERROR]: (state, action) => {
        return {
            authError: action.data,
        };
    },
    [actionTypes.SET_ERROR]: (state, action) => {
        return {
            error: action.data,
        };
    },
    [actionTypes.DISMISS_AUTH_ERROR]: () => {
        return {
            authError: null,
        };
    },
    [actionTypes.DISMISS_ERROR]: () => {
        return {
            error: null,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ExamsErrorsStore>(initialState(), actionsMap);
